import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getBotResponse } from './chatbotData';
import './Chatbot.css';

const WELCOME = {
  id: 0,
  from: 'bot',
  text: "👋 Hi! I'm the Podium Predictor assistant. Ask me anything — like how to make picks, view your history, or check the leaderboard!",
};

let nextId = 1;

const Chatbot = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([WELCOME]);
  const [input, setInput] = useState('');
  const bottomRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, open]);

  const sendMessage = () => {
    const text = input.trim();
    if (!text) return;

    const userMsg = { id: nextId++, from: 'user', text };
    const response = getBotResponse(text);
    const botMsg = { id: nextId++, from: 'bot', text: response.answer, link: response.link, linkLabel: response.linkLabel };

    setMessages(prev => [...prev, userMsg, botMsg]);
    setInput('');
  };

  const handleKey = (e) => {
    if (e.key === 'Enter') sendMessage();
  };

  return (
    <div className="chatbot-wrapper">
      {open && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <span>🏎️ Podium Assistant</span>
            <button className="chatbot-close" onClick={() => setOpen(false)}>✕</button>
          </div>
          <div className="chatbot-messages">
            {messages.map((msg) => (
              <div key={msg.id} className={`chatbot-msg chatbot-msg--${msg.from}`}>
                <p>{msg.text}</p>
                {msg.link && (
                  <button
                    className="chatbot-link-btn"
                    onClick={() => { navigate(msg.link); setOpen(false); }}
                  >
                    {msg.linkLabel} →
                  </button>
                )}
              </div>
            ))}
            <div ref={bottomRef} />
          </div>
          <div className="chatbot-input-row">
            <input
              className="chatbot-input"
              type="text"
              placeholder="Ask me anything..."
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKey}
            />
            <button className="chatbot-send" onClick={sendMessage}>Send</button>
          </div>
        </div>
      )}
      <button className="chatbot-fab" onClick={() => setOpen(o => !o)} title="Chat with Podium Assistant">
        {open ? '✕' : '💬'}
      </button>
    </div>
  );
};

export default Chatbot;
